// console.log('header', $)
// console.log('header', window.menusList)

const htmlItems = {}
const childItems = {}
const headerMobileNode = $('.header-section-m')
const popupHeaderNode = headerMobileNode.find('.le-popup--header')

const headerPcNode = $('.header-section-pc')
const navPopupSection = $('.nav-popup-section')
const navPopupBackground = $('.nav-popup-background')

initHeaderHtml()
bindClick()

function initHeaderHtml () {
    let html = '<ul class="nav-menu-main nav-menu-section child-main-model">'
    let htmlPc = ''

    window.menusList.forEach((item) => {
        if (!htmlItems[item.title]) {
            htmlItems[item.title] = {
                links: item.links || [],
                link: item.link,
                id: item.title,
                scenes: item.scenes || []
            }
        }

        html += `<li class="li" data-id="${item.title}" data-type="${item.type}" data-link="${item.link}" data-title="${item.title}">
            <${ item.links && item.links.length > 0 ? "div" : `a href="${item.link}"` } class="link-list">
                <span class="text">${item.title}</span>
                ${ item.links && item.links.length > 0 ?
                    `<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>`
                    : ''
                }
            </${ item.links && item.links.length > 0 ? "div" : `a` }>
        </li>`

        htmlPc += `<li class="li" data-id="${item.title}" data-type="${item.type}"><a href="${item.link}" class="header__menu-item list-menu__item link link--text focus-inset">
        <span>${item.title}</span>
        </a></li>`
    })

    html += '</ul>'

    fillHtml(html, htmlPc)
}

function fillHtml (html, htmlPc) {
    headerMobileNode.find('.menu-drawer__navigation').html(html)
    headerPcNode.find('.list-menu').html(htmlPc)
}
function fillChildHtml (htmlPc) {
    navPopupSection.find('.le-nav-container').html(htmlPc)
}

function bindClick () {
    headerMobileNode.on('click', '.nav-menu-main .li', function () {
        const dataType = $(this).attr('data-type') || ''
        const dataId = $(this).attr('data-id') || ''
        const dataTitle = $(this).attr('data-title') || ''
        const dataHref = $(this).find('a')

        if (dataHref.length > 0) return

        popupHeaderNode.css({ display: 'flex' })
        popupHeaderNode.find('.title-name').text(dataTitle)

        headerMobileNode.find('.all-btn-wrap').css({ display: 'none' })

        switch (dataType) {
            case 'img-text':
                fillHtml(initImgTextM(htmlItems[dataId].links || []))
                break
            case 'up-down':
                headerMobileNode.find('.all-btn-wrap').css({ display: 'block' })
                headerMobileNode.find('.all-btn-wrap .all-link').attr('href', htmlItems[dataId].link)
                fillHtml(initUpDowntM(htmlItems[dataId].links || []))
                break
            case 'scene':
                headerMobileNode.find('.all-btn-wrap').css({ display: 'block' })
                headerMobileNode.find('.all-btn-wrap .all-link').attr('href', htmlItems[dataId].link)
                fillHtml(initSceneM(htmlItems[dataId]))
                break
            case 'up-down-text-img':
                fillHtml(initUpDowntImgTextM(htmlItems[dataId].links || []))
                break
            case 'other':
                fillHtml(initOtherM(htmlItems[dataId].links || []))
                break
        }
    })

    headerMobileNode.on('click', '.nav-menu-section .li-up-down', function () {
        const dataLength = $(this).attr('data-length')
        if (dataLength == '0') {
            window.location.href = $(this).attr('data-link')
            return
        }
        if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            return
        }
        $(this).addClass('active')
    })

    popupHeaderNode.on('click', '#le_icon_arrow', function () {
        initHeaderHtml()
        popupHeaderNode.css({ display: 'none' })
        headerMobileNode.find('.all-btn-wrap').css({ display: 'none' })
    })
    popupHeaderNode.on('click', '#close-btn', function () {
        $('.header-section-m .header__icon--summary').trigger('click')
        initHeaderHtml()
        popupHeaderNode.css({ display: 'none' })
        headerMobileNode.find('.all-btn-wrap').css({ display: 'none' })
    })

    headerPcNode.on('mouseenter', '.list-menu .li', function () {
        const dataId = $(this).attr('data-id') || ''
        $(this).siblings('.li').removeClass('active')

        if (!(htmlItems[dataId].links && htmlItems[dataId].links.length > 0)) {
            navPopupSection.css({ height: 0 })
            navPopupBackground.hide()
            return
        }

        $(this).addClass('active')

        const dataType = $(this).attr('data-type') || ''

        navPopupSection.removeClass('not-style')
        navPopupSection.addClass('nav-popup-hover')
        navPopupBackground.show()

        switch (dataType) {
            case 'img-text':
                fillChildHtml(initImgTextPc(htmlItems[dataId].links))
                break
            case 'up-down':
                fillChildHtml(initUpDowntPc(htmlItems[dataId].links, htmlItems[dataId].link))
                break
            case 'scene':
                fillChildHtml(initScenePc(htmlItems[dataId]))
                break
            case 'up-down-text-img':
                fillChildHtml(initUpDowntImgTextPc(htmlItems[dataId].links))
                break
            case 'other':
                navPopupSection.addClass('not-style')
                fillChildHtml(initOtherPc(htmlItems[dataId].links))
                navPopupSection.find('.child-nav-main').css({ left: $(this)[0].offsetLeft })
                break
        }
        navPopupSection.css({ height: navPopupSection.find('.le-nav-container .child-nav-main')[0].clientHeight })
    })

    navPopupSection.on('mouseenter', '.child-nav-main .menu-child .list-hover', function () {
        $(this).siblings('.list').removeClass('active')
        $(this).addClass('active')
        const dataId = $(this).attr('data-id')
        const navActiveList = initActiveUpDowntPc(childItems[dataId])

        navPopupSection.find('.child-nav-main .menu-active-lists .lists').html(navActiveList)
    })

    $('body').on('mouseleave', '.nav-popup-section', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })
    $('body').on('mouseenter', '.nav-popup-background', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })
    $('body').on('mouseenter', '.shopify-section .utility-bar', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })

    const bodyWidth = document.querySelector('body').clientWidth || document.querySelector('html').offsetWidth
    if (bodyWidth > 0 && bodyWidth >= 990) {
        $('.header-section-pc .header-account__btn').on('click',function () {
            const dialogNode = $('.lepro-account-dialog .dialog-wrap')
            if (dialogNode.is(':visible')) {
                dialogNode.hide()
            } else {
                $('.lepro-account-dialog').css({ left: (this.offsetLeft + this.clientWidth + $('.header-section-pc')[0].offsetLeft - $('.lepro-account-dialog')[0].clientWidth)})
                dialogNode.show()
            }
        })
        $('.lepro-account-dialog').on('mouseleave',function () {
            $(this).find('.dialog-wrap').hide()
        })
    } else if (bodyWidth > 0 && bodyWidth < 990) {
        $('.header-section-m .header-account__btn').on('click',function () {
            $('.lepro-account-dialog').show()
        })
        $('.lepro-account-dialog').on('click',function (e) {
            $('.lepro-account-dialog').hide()
        })
        $('.lepro-account-dialog .dialog-wrap').on('click',function (e) {
            e.stopPropagation();
        })
    }
}

function initImgTextM (items) {
    let html = '<ul class="nav-menu-section child-main-model__2">'

    items.forEach(item => {
        html += `<li class="li">
            <a href="${item.link}" class="img-wrap">
                <img src="${item.img_url}" alt="${item.title}" class="img">
            </a>
            <a href="${item.link}" class="li-title">${item.title}</a>
        </li>`
    })

    html += `</ul>`

    return html
}

function initUpDowntM (items) {
    let html = '<ul class="nav-menu-section child-main-model child-main-model__3">'

    items.forEach(item => {
        html += `<li class="li li-up-down ${item.open == '1' ? 'active' : ''}"" data-length="${item.links && item.links.length ? 1 : 0}" data-link="${item.link}">
            <div class="link-list">
                <span class="text">${item.title}</span>
                ${ item.links && item.links.length > 0 ?
                    `<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>`
                    : ''
                }
            </div>
            <div class="nav-img-list-box">
                ${ item['model-type'] ?
                    `<div class="list-title">By Occasion</div>`
                    : ''
                }
                
                <div class="img-text-lists">
                    ${ item.links && item.links.length > 0 ?
                        item.links.map((childItem) => {
                            return `<div class="list">
                                <a href="${childItem.link}" class="img-wrap">
                                    <img src="${childItem.img_url}" alt="${childItem.title}" class="img">
                                </a>
                                <a href="${childItem.link}" class="list-title">${childItem.title}</a>
                                ${ item['model-type'] ?
                                    ''
                                    : `<a href="${childItem.link}" class="list-more">more</a>`
                                }
                            </div>
                            `
                        }).join('')
                        : ''
                    }
                </div>
            </div>
        </li>`
    })

    html += `</ul>`

    return html
}

function initSceneM (items) {
    let html = ''

    if (items.links && items.links.length > 0) {
        html = '<div class="child-main-model__3 list-nav-title">By Category</div><ul class="nav-menu-section nav-menu-section-scene child-main-model child-main-model__3">'

        items.links.forEach(item => {
            html += `<li class="li" data-length="${item.links && item.links.length ? 1 : 0}" data-link="${item.link}">
                <a href="${item.link}" class="link-list">
                    <span class="text">${item.title}</span>
                </a>
            </li>`
        })
    
        html += `</ul>`
    }

    html += `<div class="nav-img-list-box nav-img-list_model_3">
        <div class="list-nav-title">By Occasion</div>
        
        <div class="img-text-lists">
            ${ items.scenes && items.scenes.length > 0 ?
                items.scenes.map((childItem) => {
                    return `<div class="list">
                        <a href="${childItem.link}" class="img-wrap">
                            <img src="${childItem.img_url}" alt="${childItem.title}" class="img">
                        </a>
                        <a href="${childItem.link}" class="list-title">${childItem.title}</a>
                    </div>
                    `
                }).join('')
                : ''
            }
        </div>
    </div>`

    return html
}

function initUpDowntImgTextM (items) {
    let html = '<ul class="nav-menu-section child-main-model child-main-model__4">'

    items.forEach(item => {
        html += `<li class="li li-up-down ${item.open == '1' ? 'active' : ''}" data-length="${item.links && item.links.length ? 1 : 0}" data-link="${item.link}">
            <div class="link-list">
                <span class="text">${item.title}</span>
                ${ item.links && item.links.length > 0 ?
                    `<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>`
                    : ''
                }
            </div>
            
            ${
                item.type == 'img-text' ?
                `<div class="img-text-lists">
                    ${ item.links && item.links.length > 0 ?
                        item.links.map((childItem) => {
                            return `<div class="list">
                                <a href="${childItem.link}" class="img-wrap">
                                    <img src="${childItem.img_url}" alt="${childItem.title}" class="img">
                                </a>
                                <a href="${childItem.link}" class="list-title">${childItem.title}</a>
                            </div>`
                        }).join('')
                        : ''
                    }
                </div>`
                :
                `<div class="nav-img-list-box">
                    <div class="link-lists">
                        ${ item.links && item.links.length > 0 ?
                            item.links.map((childItem) => {
                                return `<div class="list">
                                    <a href="${childItem.link}" class="list-title">${childItem.title}</a>
                                </div>`
                            }).join('')
                            : ''
                        }
                    </div>
                </div>`
            }
        </li>`
    })

    html += `</ul>`

    return html
}

function initOtherM (items) {
    let html = '<ul class="nav-menu-section child-main-model__5">'

    items.forEach(item => {
        html += `<li class="li">
            <svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${item.icon}"></use></svg>
            <a href="${item.link}" class="text">${item.title}</a>
        </li>`
    })

    html += `</ul>`

    return html
}

function initImgTextPc (items) {
    let html = '<div class="child-nav-main child-main-model-1">'

    items.forEach(item => {
        html += `<div class="text-img-link">
            <a href="${item.link}" class="img-wrap">
                <img src="${item.img_url}" alt="${item.title}" class="img">
            </a>
            <a href="${item.link}" class="link-title">${item.title}</a>
        </div>`
    })

    html += `</div>`

    return html
}

function initUpDowntPc (items, link) {
    let navList = ''
    let navActiveList = ''
    let firstActive = null
    items.forEach((item, index) => {
        if (firstActive === null && item.links && item.links.length > 0) {
            firstActive = index
            
            navActiveList = initActiveUpDowntPc(item)
        }
        navList += `<a href="${item.link}" data-id="${item.title}" class="list list-hover justify-between align-items-center ${firstActive === index ? 'active' : ''}">${item.title} ${item.links && item.links.length ? '<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>' : ''}</a>`

        if (!childItems[item.title]) {
            childItems[item.title] = {
                links: item.links
            }
            if (item['model-type']) childItems[item.title]['model-type'] = item['model-type']
        }
    })

    const html = `<div class="child-nav-main child-main-model-2">
        <div class="menu-child">
            <div class="lists">
                ${navList}
            </div>

            <div class="list-all">
                <a href="${link}" class="all-link">Shop All</a>
            </div>
        </div>
        <div class="menu-active-lists">
            <div class="lists">
                ${navActiveList}
            </div>
        </div>
    </div>`

    return html
}

function initScenePc (items) {
    let navList = ''
    let navActiveList = ''
    if (items.links && items.links.length > 0) {
        items.links.forEach((item) => {
            navList += `<a href="${item.link}" data-id="${item.title}" class="list ">${item.title}</a>`
    
            if (!childItems[item.title]) {
                childItems[item.title] = {
                    links: item.links
                }
                if (item['model-type']) childItems[item.title]['model-type'] = items.type
            }
        })
    }

    if (items.scenes && items.scenes.length > 0) {
        navActiveList = initActiveScenePc(items.scenes)
    }

    const html = `<div class="child-nav-main child-main-model-2">
        <div class="menu-child">
            <div class="lists">
                <div class="list-nav-title">By Category</div>
                ${navList}
            </div>

            <div class="list-all">
                <a href="${items.link}" class="all-link">Shop All</a>
            </div>
        </div>
        ${navActiveList}
    </div>`

    return html
}

function initActiveUpDowntPc (item) {
    let childNavList = ''
    
    item.links.forEach(childItem => {
        childNavList += `<div class="list">
            <a href="${childItem.link}" class="img-wrap">
                <img src="${childItem.img_url}" alt="${childItem.title}" class="img">
            </a>
            <div class="tag">Hot</div>
            <a href="${childItem.link}" class="link-title">${childItem.title}</a>
        </div>`
    })

    return childNavList
}

function initActiveScenePc (item) {
    let navActiveList = ''
    let childNavList = ''
    
    item.forEach(childItem => {
        childNavList += `<div class="list">
            <a href="${childItem.link}" class="img-wrap">
                <img src="${childItem.img_url}" alt="${childItem.title}" class="img">
            </a>
            <a href="${childItem.link}" class="link-title">${childItem.title}</a>
        </div>`
    })
    navActiveList = `<div class="menu-active-lists-model_2">
            <div class="menu-title">By Occasion</div>
            <div class="lists">
                ${childNavList}
            </div>
        </div>`
        
    return navActiveList
}

function initUpDowntImgTextPc (items) {
    let html = '<div class="child-nav-main child-main-model-3"><div class="nav-lists">'

    items.forEach(item => {
        html += `
            ${
                item.type == 'img-text' ?
                `<div class="nav-list width39">
                    <div class="list-title">${item.title}</div>
                    <div class="img-text-lists">
                        ${ item.links && item.links.length > 0 ?
                            item.links.map((childItem) => {
                                return `<div class="img-text-list">
                                    <a href="${childItem.link}" class="img-wrap">
                                        <img src="${childItem.img_url}" alt="${childItem.title}" class="img">
                                    </a>
                                    <div class="img-text-link">
                                        <a href="${childItem.link}" class="link">${childItem.title}</a>
                                    </div>
                                </div>`
                            }).join('')
                            : ''
                        }
                    </div>
                </div>`
                :
                `<div class="nav-list">
                    <div class="list-title">${item.title}</div>
                    ${ item.links && item.links.length > 0 ?
                        item.links.map((childItem) => {
                            return `<a href="${childItem.link}" class="nav-link">${childItem.title}</a>`
                        }).join('')
                        : ''
                    }
                </div>`
            }
        `
    })

    html += `</div></div>`

    return html
}

function initOtherPc (items) {
    let html = '<div class="child-nav-main child-main-model-4"><div class="nav-lists">'

    items.forEach(item => {
        html += `<a href="${item.link}" class="li">
            <svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${item.icon}"></use></svg>
            <span class="text">${item.title}</span>
        </a>`
    })

    html += `</div></div>`

    return html
}